var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"new-contact"}},[_c('div',{staticClass:"card-container"},[_c('div',{staticClass:"local-subheader"},[_c('div',{staticClass:"user-management-icon"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('newContact')))])]),_vm._v(" "),_c('NewContactForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }